import classes from "./ActionBtn.module.css";

export function ActionBtn({
  imgSrc,
  text,
  onClick,
  disabled,
  height,
  type = "button",
  width,
  btnType = "default",
}) {
  return (
    <button
      className={`${classes.btn} ${
        btnType === "default" ? classes.actionBtn : classes.cancelBtn
      }`}
      onClick={onClick}
      disabled={disabled}
      type={type}
      style={{ height: height ? height : "", width: width ? width : "" }}
    >
      {imgSrc && <img src={imgSrc} />} {text}
    </button>
  );
}
